import React from "react";

const PmMatrixFilters = ({
  filters,
  onFilterChange,
  plants,
  assets,
  plans,
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - 2 + i);

  return (
    <div className="matrix-filters horizontal-filters">
      <div className="filter-item">
        <label>
          <span className="filter-icon">🌐</span> Plant / Facility
        </label>
        <select
          value={filters.plantId}
          onChange={(e) => onFilterChange("plantId", e.target.value)}
          className="compact-select"
        >
          <option value="">All Facilities</option>
          {plants.map((p) => (
            <option key={p.plantId} value={p.plantId}>
              {p.plantName}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-item">
        <label>
          <span className="filter-icon">⚙️</span> MACHINES
        </label>
        <select
          value={filters.assetId}
          onChange={(e) => onFilterChange("assetId", e.target.value)}
          className="compact-select"
        >
          <option value="">All Machines </option>
          {assets
            .filter(
              (a) =>
                !filters.plantId || a.plantId === parseInt(filters.plantId),
            )
            .map((a) => (
              <option key={a.machineId} value={a.machineId}>
                {a.machineName}
              </option>
            ))}
        </select>
      </div>

      <div className="filter-item">
        <label>
          <span className="filter-icon">📝</span> Maintenance Plan
        </label>
        <select
          value={filters.planId}
          onChange={(e) => onFilterChange("planId", e.target.value)}
          className="compact-select"
        >
          <option value="">All Plans</option>
          {plans.map((p) => (
            <option key={p.maintenancePlanId} value={p.maintenancePlanId}>
              {p.planName}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-item year-filter">
        <label>
          <span className="filter-icon">📅</span> Year
        </label>
        <select
          value={filters.year}
          onChange={(e) => onFilterChange("year", e.target.value)}
          className="compact-select"
        >
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default PmMatrixFilters;
